/*jshint maxcomplexity:false */
angular.module("formApp").service("excessMessageService",
    function () {

        function getProduct(products, pet) {
            var prod = products.filter(function (prod) {
                return prod.pet === pet.uri && prod.id === pet.chosenCover.productId;
            });
            return prod[0];
        }

        return {
            getExcessMessage: function (products, pet) {
                var excessPet = angular.copy(pet);                
                var message = "";
                var part1 = 'To help keep premiums affordable, as your pet gets older you will be required to contribute more towards the cost of your claim.';
                var part2 = 'We may increase the fixed excess you pay from time to time; this will only happen at your renewal.';
                var part3 = 'We may increase the fixed excess you pay from time to time; this will only happen at your renewal. We won\'t increase the percentage amount.';


                function youngerExcess(year) {
                    return "From the renewal after your pet is " + year + ", you'll pay 20% of all vet bills (on top of your fixed excess). We'll remind you of this a year before it happens.";
                }

                function olderExcess() {
                    return "As your pet is older, you'll pay 20% of all vet bills (on top of your fixed excess), this is to help keep premiums affordable.";
                }

                function excessThisYear(year) {
                    return "From the renewal after your pet is " + year + " you'll pay 20% of all vet bills (on top of your fixed excess). We'll remind you of this a year before it happens.";
                }
                
                var prod = getProduct(products, pet);
                if (prod.selectBreed && prod.selectBreed === 'true') {
                    excessPet.selectBreed = true;
                }
                if (prod.age) {
                    // console.log('prod age', prod.age);
                    excessPet.age = parseInt(prod.age, 10);
                    // console.log('excess pet', excessPet.age);
                }

                if (excessPet.type === 'dog' || excessPet.type === 'cat') {
                    if (!excessPet.selectBreed) {
                        if (excessPet.chosenCover.productLine === 'C4L') {

                            if (excessPet.age < 9) {
                                message = part1 + " " + youngerExcess(10) + " " + part2;
                            }
            
                            if (excessPet.age === 9) {
                                message = part1 + " " + excessThisYear(10) + " " + part2;
                            }
            
                            if (excessPet.age >= 10) {
                                message = olderExcess() + " " + part3;
                            }
                        }
        
                        if (excessPet.chosenCover.productLine === 'Essential') {
                            if (excessPet.age < 7) {
                                message = part1 + " " + youngerExcess(8) + " " + part2;
                            }
            
                            if (excessPet.age === 7) {
                                message = part1 + " " + excessThisYear(8) + " " + part2;
                            }
            
                            if (excessPet.age >= 8) {
                                message = olderExcess() + " " + part3;
                            }
                        }
                    }

                    if (excessPet.selectBreed) {
                        if (excessPet.chosenCover.productLine === 'C4L') {

                            if (excessPet.age < 6) {
                                message = part1 + " " + youngerExcess(7) + " " + part2;
                            }
            
                            if (excessPet.age === 6) {
                                message = part1 + " " + excessThisYear(7) + " " + part2;
                            }
            
                            if (excessPet.age >= 7) {
                                message = olderExcess() + " " + part3;
                            }
                        }

                        if (excessPet.chosenCover.productLine === 'Essential') {

                            if (excessPet.age < 4) {
                                message = part1 + " " + youngerExcess(5) + " " + part2;
                            }
            
                            if (excessPet.age === 4) {
                                message = part1 + " " + excessThisYear(5) + " " + part2;
                            }
            
                            if (excessPet.age >= 5) {
                                message = olderExcess() + " " + part3;
                            }
                        }
        
                    }

                }

                if (excessPet.type === 'rabbit') {
                    if (excessPet.age < 6) {
                        message = part1 + " " + youngerExcess(7) + " " + part2;
                    }
    
                    if (excessPet.age === 6) {
                        message = part1 + " " + excessThisYear(7) + " " + part2;
                    }
    
                    if (excessPet.age >= 7) {
                        message = olderExcess() + " " + part3;
                    }
                }
                return message;
            }
        };
    });